export default __webpack_public_path__ + "static/media/Cars_01.a6b12521.png";